import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({


    state: {
        msgLoaded: false,
        suggerimenti: [],
        contatti: [],
        user: {
            loaded: false,
            name: '',
            role: '',
        },
        languages: [
            {
                label: 'ITA',
                value: 'it'
            },
            {
                label: 'ENG',
                value: 'en'
            }
        ],

        current_lang: '',

        fallback_lang: 'it',

        // flag per verificare se sono state caricate le informazioni dell'utente
        // loaded: false,

        // sublocality to exclude for shipping zone creation
        localities: [
            'locality', 'sublocality', 'postal code', 'administrative_area_level_3'
        ],

        // durata animazione modals
        modal_delay: {
            center: 200,
            right: 400
        },

        // registro i messaggi dell'utente
        messages: [],

        // registro le notifiche dell'utente
        notifications: [],

        // registro l'utente corrente che sta navigando
        nav: null,

        // registro gli elementi nel carrello dell'utente che sta navigando
        cart: {
            articles: [],
            messages: [],
            errors: [],
        },

        general_messages: {
            'error': 'Si è verificato un errore imprevisto, impossibile completare l\'operazione'
        },

        contenuti_pagine: null,

        /**
         * loader globale dell'intera applicazione
         */
        app_loading: false,

        // tree: [],
        // currentColors: [],
        cartKey: 0,
        acquistoVeloce: false,
        aVproducts: null,
        avKey: 0,
        openedCart: false,
        catalog: {
            catcolor: null,
        },
        tempCatalog: {
            catcolor: null,
        },
        breadcrumb: null,
        openedFilter: false,
        isSearchCat: false,
        isSearchCol: false,
        currentCatSelection: null,
        currentColSelection: null,
        filterKey: 0,
    },

    mutations: {
        setCurrentCat(state, payload) {
            state.currentCatSelection = payload
        },
        setCurrentCol(state, payload) {
            state.currentColSelection = payload
        },
        setSearcCat(state, payload) {
            state.isSearchCat = payload;
        },
        setSearcCol(state, payload) {
            state.isSearchCol = payload;
        },
        openFilter(state) {
            state.openedFilter = !state.openedFilter
        },
        setBread(state, payload) {
            state.breadcrumb = payload
        },
        setCatColors(state, payload) {
            state.catalog.catcolor = payload
        },
        setCatColorsTemp(state, payload) {
            state.tempCatalog.catcolor = payload
        },

        openCart(state) {
            state.openedCart = true
        },
        closeCart(state) {
            state.openedCart = false
        },
        showAcquistoVeloce(state, payload) {
            state.acquistoVeloce = payload.status;
            state.aVproducts = {
                macro: payload.macro,
                family: payload.family,
                category: payload.category,
                color: payload.color,
                cod_art: payload.cod_art

            }

        },
        add_message(state, data) {

            state.messages.push({
                type: data.type,
                message: data.message,
                id: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
                autoclose: data.autoclose != null ? data.autoclose : true
            });

        },

        delete_message(state, id) {

            var index = state.messages.map(function (e) {
                return e.id;
            }).indexOf(id);
            state.messages.splice(index, 1);

        },

        load_nav_data(state, data) {

            state.nav = data;
            state.app_loading = false;

        },

        load_contenuti_pagine(state, data) {

            state.contenuti_pagine = data;

        },

        set_current_lang(state, data) {

            state.current_lang = data;

        },

        set_app_loading(state, data) {

            state.app_loading = data;

        }

    },

    actions: {
        getMessages: function ({context, state}) {
            state.msgLoaded = false;
            axios({
                method: 'get',
                url: window.location.origin + "/admin/getMessages",
            })
                .then((res) => {
                    if (res.data.success) {
                        state.suggerimenti = res.data.suggerimenti;
                        state.contatti = res.data.contatti;
                        state.msgLoaded = true;
                        // console.log(state.suggerimenti);
                    } else {
                        console.log("insuccesso");
                    }
                })
                .catch((error) => {
                    console.log(error.response.data);
                });

        },
        getUserName: function ({context, state}) {
            axios({
                method: "get",
                url: window.location.origin + "/getUserName",
            })
                .then((res) => {
                    if (res.data.success) {
                        state.user.loaded = true;
                        state.user.name = res.data.data.username;
                        state.user.role = res.data.data.user.id_ruolo;
                    } else {
                        // console.log("no");
                    }
                })
                .catch((error) => {
                    console.log(error.response.data);
                });
        },

        refreshCart: function ({context, state}) {
            state.cartKey++
        },
        refreshAv: function ({context, state}) {
            state.avKey++
        },
        refreshFilter: function ({context, state}) {
            state.filterKey++
        },
        addItemToCart: function (context, payload) {
            axios({
                method: 'get',
                url: window.location.origin + '/b2b/cart',
                params: {
                    action: 'AddItem',
                    codart: payload.codart,
                    quantita: payload.quantita,
                    prezzo: payload.prezzo,
                    prezzo_unitario: payload.prezzo_unitario,
                }
            })
            .then(result => {

                context.dispatch('refreshCart');

            })
            .catch(error => {
                console.log(error.response.data)
            })

        },
        deleteItemCart: function (context, payload) {
            axios({
                method: 'get',
                url: window.location.origin + '/b2b/cart',
                params: {
                    action: 'destroyCartItem',
                    codart: payload.codart,
                }
            })
                .then(result => {
                    //  console.log('deleted_item', result)
                    context.dispatch('refreshCart');
                })
                .catch(error => {
                    console.log(error.response.data.message)
                })
        },

        /**
         * Carica i dati dell'utente corrente
         */
        get_navigation_data: function (context) {

            let nav_data = axios({
                method: 'get',
                url: window.location.origin + "/data/get-nav-info",
              })
              .then(res => {
                
                  context.commit('load_nav_data', res.data.user)
  
              })

        },

        get_contenuti_pagine: function (context) {

            axios({
                method: "get",
                url: window.location.origin + '/data/contenuti-pagine',
            })
                .then(res => {
                    context.commit('load_contenuti_pagine', res.data.contenuti);
                    //console.log('Dati contenuti_pagine caricata nell\'istanza vue...')
                })
                .catch(err => {

                    console.log('Errore nel caricamento dei dati contenuti pagine')
                    console.log('================');
                    console.log(err);
                    console.log('================');

                })

        },

        // ...processo spostato nell'istanza vue principale
        // start_broadcasting: function(){
        // }
        // filter
        // loadColors: function (context, codcat) {
        //   let listaColori = $(".lista-colori:hidden");
        //   let checkbox = $("#" + codcat);
        //   if (listaColori) {
        //     listaColori.show();
        //   } else {
        //     listaColori.hide();
        //   }
        //   axios({
        //     method: "get",
        //     url: window.location.origin + "/data/get-family",
        //     params: {
        //       cod: codcat,
        //       type: "colori_f",
        //     },
        //   })
        //       .then((result) => {
        //         if (checkbox.prop("checked")) {
        //           // se selezionato
        //           result.data.family.forEach((item, i) => {
        //             var trovato = context.currentColors.find(function (obj, i) {
        //               return obj.code === item.cod_colore;
        //             });
        //             if (trovato) {
        //               let index = context.currentColors.findIndex(function (el) {
        //                 return el.code === item.cod_colore;
        //               });
        //               context.currentColors[index].count++;
        //             } else {
        //               context.currentColors.push({
        //                 code: item.cod_colore,
        //                 descrizione: item.color.descrizione,
        //                 count: 1,
        //               });
        //             }
        //           });
        //         } else {
        //           //se deselezionato
        //           result.data.family.forEach((item, i) => {
        //             var trovato = context.currentColors.find(function (obj, i) {
        //               return obj.code === item.cod_colore;
        //             });
        //             if (trovato) {
        //               let index = context.currentColors.findIndex(function (el) {
        //                 return el.code === item.cod_colore;
        //               });
        //               context.currentColors[index].count--;
        //             }
        //           });
        //         }
        //         context.currentColors = context.currentColors.filter((el) => el.count > 0);
        //       })
        //       .catch((err) => {
        //         context.commit("add_message", {
        //           type: "error",
        //           message: err.response.data.message,
        //         });
        //       });
        // },
        // loadMacro: function (context) {
        //   axios({
        //     method: "get",
        //     url: window.location.origin + "/data/get-family",
        //     params: {
        //       type: "filter-m",
        //     },
        //   })
        //       .then((result) => {
        //         let macro = result.data.family;
        //         let tutto = [];
        //         //console.log('loadmacro: ', result.data.family)
        //         macro.forEach((item, index) => {
        //           let key = item.codice;
        //          this.dispatch('loadFamily', item.codice, function (res) {
        //             tutto.push({
        //               code: item.codice,
        //               descrizione: item.descrizione,
        //               famiglie: res,
        //             });
        //           });
        //         })
        //
        //         context.tree = tutto;
        //
        //       })
        //       .catch((err) => {
        //
        //         context.commit("add_message", {
        //           type: "error",
        //           message: err.response.data.message,
        //         });
        //       });
        // },
        // loadFamily: ({context, macrofam}, data) => {
        //   axios({
        //     method: "get",
        //     url: window.location.origin + "/data/get-family",
        //     params: {
        //       cod: macrofam,
        //       type: "filter-f",
        //     },
        //   })
        //       .then((result) => {
        //         let famiglie = result.data.family;
        //         let tutto_f = [];
        //         famiglie.forEach((item) => {
        //           if (item.microfamily.length > 0) {
        //             this.dispatch('loadMicro', item.codice, function (res) {
        //               tutto_f.push({
        //                 code: item.codice,
        //                 descrizione: item.descrizione,
        //                 microfamiglie: res,
        //               });
        //               //console.log(item.codice, res)
        //             });
        //           } else {
        //             this.dispatch('loadCategoriesNoMicro',item.codice, function (res) {
        //               tutto_f.push({
        //                 code: item.codice,
        //                 descrizione: item.descrizione,
        //                 microfamiglie: null,
        //                 categorie: res,
        //               });
        //             });
        //           }
        //         });
        //
        //         data.callback(tutto_f);
        //       })
        //
        // },
        // loadMicro:  ({context, family}, data) => {
        //   axios({
        //     method: "get",
        //     url: window.location.origin + "/data/get-family",
        //     params: {
        //       cod: family,
        //       type: "filter-micro",
        //     },
        //   })
        //       .then((result) => {
        //         let microfamilies = result.data.family;
        //         let tutto_micro = [];
        //
        //         if (microfamilies.length > 0) {
        //           microfamilies.forEach((el) => {
        //             this.dispatch('loadCategories',el.codice, function (res) {
        //               if (res.length > 0) {
        //                 tutto_micro.push({
        //                   code: el.codice,
        //                   descrizione: el.descrizione,
        //                   microfamily: true,
        //                   categorie: res,
        //                 });
        //               }
        //             });
        //           });
        //           //console.log(family, tutto_micro)
        //           data.callback(tutto_micro);
        //         }
        //       })
        //
        // },
        // loadCategories: ({context, microfam}, data) => {
        //   axios({
        //     method: "get",
        //     url: window.location.origin + "/data/get-family",
        //     params: {
        //       cod: microfam,
        //       type: "filter-categories",
        //     },
        //   })
        //       .then((result) => {
        //         let microfamilies = result.data.family;
        //         let tutto_c = [];
        //
        //         if (microfamilies.length > 0) {
        //           microfamilies.forEach((el) => {
        //             tutto_c.push({
        //               code: el.cod_categoria,
        //               descrizione: el.category.descrizione,
        //             });
        //           });
        //         } else {
        //           tutto_c.push(null);
        //         }
        //
        //         data.callback(tutto_c);
        //       })
        //
        // },
        // loadCategoriesNoMicro: ({context, fam}, data) => {
        //   axios({
        //     method: "get",
        //     url: window.location.origin + "/data/get-family",
        //     params: {
        //       cod: fam,
        //       type: "filter-categories-nomicro",
        //     },
        //   })
        //       .then((result) => {
        //         let families = result.data.family;
        //         let tutto_c = [];
        //
        //         if (families.length > 0) {
        //           families.forEach((el) => {
        //             tutto_c.push({
        //               code: el.cod_categoria,
        //               descrizione: el.category.descrizione,
        //             });
        //           });
        //         }
        //         data.callback(tutto_c);
        //       })
        //
        // },

    },

    getters: {

        contenuto: (state) => (slug) => {
            if (state.contenuti_pagine && slug in state.contenuti_pagine) {
                return state.contenuti_pagine[slug].testo;
            } else {
                return '';
            }
        },


    }

})
